import React from "react";
import { AgentBrain, BRAINS, SHORT, brainColor } from "./AgentBrain";
import { useHouseLive, STATUS_COLOR } from "./useHouseLive";

const POS = [[22, 12], [78, 12], [78, 37], [22, 37], [22, 62], [78, 62], [78, 87], [22, 87]];

export const SlideWorkflow = ({ st }) => {
  const live = Object.fromEntries(useHouseLive().map((x) => [x.agent, x]));
  return (
    <div className="relative w-full h-full" data-testid="floor-slide-workflow">
      <svg viewBox="0 0 100 100" preserveAspectRatio="none" className="absolute inset-0 w-full h-full">
        {POS.slice(1).map((p, i) => {
          const q = POS[i], fire = true;
          return (
            <g key={i}>
              <line x1={q[0]} y1={q[1]} x2={p[0]} y2={p[1]} stroke="rgba(0,240,255,0.12)" strokeWidth="1" vectorEffect="non-scaling-stroke" />
              {fire && <line className="fc-fire" x1={q[0]} y1={q[1]} x2={p[0]} y2={p[1]} stroke={brainColor(BRAINS[i + 1])} strokeWidth="2.5" vectorEffect="non-scaling-stroke" data-testid={`floor-edge-fire-${BRAINS[i + 1]}`} />}
            </g>
          );
        })}
      </svg>
      {BRAINS.map((a, i) => {
        const s = st[a] || {};
        return (
          <div key={a} className="absolute -translate-x-1/2 -translate-y-1/2 flex flex-col items-center text-center w-[42%]" style={{ left: `${POS[i][0]}%`, top: `${POS[i][1]}%` }} data-testid={`floor-flow-${a}`} data-active={!!s.active}>
            <AgentBrain agent={a} size={44} active />
            <p className="nx-orbitron text-[11px] font-bold mt-1" style={{ color: brainColor(a) }}>{SHORT[a]}</p>
            <p className="fc-num text-[9px] font-bold" style={{ color: STATUS_COLOR[live[a]?.status] }} data-testid={`floor-flow-status-${a}`}>{live[a]?.status || ""}</p>
            <p className="fc-num text-[10px] text-cyan-50/90 leading-tight line-clamp-2" data-testid={`floor-flow-task-${a}`}>{live[a]?.task || s.task}</p>
          </div>
        );
      })}
    </div>
  );
};
